import React from 'react'
import { getText } from '../shared/customization';

export default function Contact() {
  return (
    <div>
      {getText('Contact.Title')}
    </div>
  )
}
